import dynamic from "next/dynamic";
import { useMemo } from "react";
import { CANVAS } from "../apollo/queries/canvas";
import Loading from "../components/Loading";
import { useAuthUserQuery } from "../hooks";
import config from "../lib/config";
import { CANVAS_PAGE_LIMIT } from "../lib/constants";
import withMiddlewares from "../middlewares/withMiddlewares";
const Canvas = dynamic(() => import("../components/Canvas"));

function getIdKey(user) {
  if (user) {
    return config.canvas.loginTop["vod"];
  } else {
    return config.canvas.top["vod"];
  }
}

export default function Home() {
  const { loading: userLoading, data: userData } = useAuthUserQuery();
  const user = userData?.user;

  const key = useMemo(() => {
    return getIdKey(user);
  }, [user]);

  if (userLoading) {
    return <Loading fixed />;
  }

  return <Canvas idKey={key} />;
}

export const getServerSideProps = withMiddlewares(
  async ({ req }, { serverProps, error, apolloClient }) => {
    const idKey = getIdKey(req.userToken);
    await apolloClient.query({
      query: CANVAS,
      variables: {
        idKey: idKey.toString(),
        offset: 0,
        limit: CANVAS_PAGE_LIMIT,
      },
    });

    return {
      props: {
        ...serverProps,
        error,
        initialApolloState: apolloClient.cache.extract(),
      },
    };
  }
);
